import { useTranslation } from 'react-i18next';

import { Button, Drawer } from '@/components';

import { CompanySchema } from '../../types';
import { InvoicingForm, InvoicingFormFields } from './invoicing-form';

export type InvoicingDrawerProps = {
  readonly formId: string;
  readonly company: CompanySchema;
  readonly isOpen: boolean;
  readonly isLoading?: boolean;
  readonly onSubmit: (data: InvoicingFormFields) => void;
  readonly onClose: () => void;
};

export function InvoicingDrawer({ formId, company, isOpen, isLoading, onSubmit, onClose }: InvoicingDrawerProps) {
  const { t } = useTranslation(['settings']);

  const footer = (
    <>
      <Button size="lg" color="neutral" onClick={onClose}>
        {t('Cancel')}
      </Button>
      <Button type="submit" form={formId} size="lg" color="primary" disabled={isLoading}>
        {t('Save')}
      </Button>
    </>
  );

  return (
    <Drawer title={t('Invoicing data')} open={isOpen} onClose={onClose} footer={footer}>
      <InvoicingForm id={formId} company={company} onSubmit={onSubmit} />
    </Drawer>
  );
}
